/**
 * @note Make sure this is the same in both frontend and service api repo
 */
enum ErrorCodeEnum {
  // More general errors
  CAPTCHA_FAILED = 9000,

  // Nuki premium related errors
  NUKI_PREMIUM_LIFETIME_DEVICE_ALREADY_HAS_ACTIVE_SUBSCRIPTION = 10001,
  NUKI_PREMIUM_LIFETIME_DEVICE_INVALID = 10002,
  NUKI_PREMIUM_LIFETIME_DEVICE_REGION_UNSUPPORTED = 10003,
  NUKI_PREMIUM_LIFETIME_SUBMISSION_FAILED = 10004,
  NUKI_PREMIUM_LIFETIME_CAPTCHA_VALIDATION_FAILED = 10005,

  NUKI_PREMIUM_LIFETIME_REFERRER_MUST_BE_A_NUKI_PREMIUM_USER = 10100,
  NUKI_PREMIUM_LIFETIME_REFERRER_NOT_FOUND = 10101,

  // Service transfer related errors
  SERVICE_TRANSFER_TARGET_ALREADY_ACTIVE = 11001,
  SERVICE_TRANSFER_TARGET_TYPE_UNSUPPORTED = 11002,
  SERVICE_TRANSFER_TARGET_SAME_AS_SOURCE = 11003,
  SERVICE_TRANSFER_DEVICE_TYPE_UNRESOLVED = 11004,
  SERVICE_TRANSFER_INCOMPLETE = 11005,
  SERVICE_TRANSFER_TARGET_TIMEFRAME_EXCEEDED = 11006,
  SERVICE_TRANSFER_TARGET_NOT_ELIGIBLE = 11007,

  // Withdrawal related errors
  WITHDRAWAL_WINDOW_EXCEEDED = 13001,
  WITHDRAWAL_ALREADY_REQUESTED = 13002,
  WITHDRAWAL_NOT_ELIGIBLE = 13003,
  WITHDRAWAL_LINK_EXPIRED = 13004,
  WITHDRAWAL_COUNTRY_NOT_SUPPORTED = 13005,
  WITHDRAWAL_TEMPORARILY_UNAVAILABLE = 13006,

  // Return / shipping related errors
  RETURN_IMPORT_INVOICE_DATA_INCOMPLETE = 120125,
}

export default ErrorCodeEnum;
